module.exports = __webpack_public_path__ + "img/feriavalencia-logo.0d6abc19.png";